import React, { useState } from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { resetPassword } from "../../api/api";
import { useNavigate } from "react-router-dom";
import bgImg from "../../assets/images/right.jpg";

const ResetComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const params = new URLSearchParams(document.location.search);
  const uid = params.get("uid");
  const token = params.get("token");

  const onFinish = async (values) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!regex.test(values.password)) {
      message.error(
        "Password should contain at least one lowercase, one uppercase, one digit, one special char, and min 8 chars."
      );
      return;
    }

    try {
      setIsLoading(true);
      const { data, res } = await resetPassword({
        password: values.password,
        uid,
        token,
      });

      if (res.status === 200) {
        message.success("Password Reset Successfully.");
        navigate("/auth/login/");
      } else {
        message.error(data.message);
      }
    } catch (err) {
      message.error("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  return (

      <div className="glass-card shadow-lg rounded-lg p-10 w-full max-w-md">
        <h1 className="text-center text-2xl font-bold mb-6 text-white">Reset Password</h1>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="password"
            label="New Password"
            rules={[{ required: true, message: "Please enter your password." }]}
          >
            <Input.Password   placeholder="********" />
          </Form.Item>

          <Form.Item
            name="confirm"
            label="Confirm Password"
            dependencies={["password"]}
            hasFeedback
            rules={[
              { required: true, message: "Please confirm your password." },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    "The two passwords do not match."
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="********" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              block
              htmlType="submit"
              loading={isLoading}
              style={{ backgroundColor: "#122253", borderColor: "#4E36A3",borderRadius: "8px", height: "40px" }}
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
      </div>
  );
};

export default ResetComponent;
